import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LayoutContainerModes } from '@my7n/ui';

@Component({
  selector: 'availability-update-main',
  standalone: false,
  templateUrl: './availability-update-main.component.html',
  styleUrls: ['./availability-update-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvailabilityUpdateMainComponent {
  LayoutContainerModes = LayoutContainerModes;
}
